import BaseApi from './base/BaseApi';

export default class TaskApi extends BaseApi {
  static entityName = 'tasks';
}
